export default __webpack_public_path__ + "static/media/association.3cd506a1.png";